import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20golden%20abstract%20background%20with%20elegant%20flowing%20curves%20and%20soft%20light%20gradients%2C%20luxurious%20atmosphere%2C%20deep%20burgundy%20and%20warm%20gold%20tones%2C%20subtle%20particle%20effects%2C%20premium%20brand%20background%20for%20website%20call%20to%20action%20section&width=1920&height=500&seq=cta-bg-home-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/60"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-background-50 mb-4">
          寻找最适合您的博彩平台？
        </h2>
        <p className="text-sm md:text-base text-background-200/80 mb-8 max-w-xl mx-auto leading-relaxed">
          博彩网为您精选200+正规平台，专业评测帮您做出明智选择。立即浏览我们的平台推荐，开启安全博彩之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/pingce"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 rounded-md text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap"
          >
            查看平台评测
          </Link>
          <Link
            to="/category/anquan"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md text-base font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
          >
            安全指南
          </Link>
        </div>
      </div>
    </section>
  );
}